import React, { useMemo } from "react";
import { SubscribedChart } from "@client/components/valueDisplays/SubscribedChart";
import type { BmsTelemetry } from "@client/types/bms";

interface Props {
  slug: string;
  telemetry: BmsTelemetry | undefined;
}

/**
 * Graf vývoje výkonu v čase pro detail BMS — stejný graf jako hlavní stránka, nad MQTT topicem
 * power/val. Hlavička ukazuje ŽIVOU hodnotu (pack.powerMw/1000) shodnou s overview; graf kreslí
 * 15s-průměrovanou MQTT řadu.
 *
 *  - výkon packu (power) — signed (kladný = vybíjení, záporný = nabíjení)
 */
export const BmsCharts: React.FC<Props> = ({ slug, telemetry }) => {
  const prefix = `zige/bms-${slug}`;
  const power = useMemo(() => [`${prefix}/power/val`], [prefix]);

  return (
    <>
      <SubscribedChart topicIds={power} liveValue={telemetry ? telemetry.pack.powerMw / 1000 : undefined} />
    </>
  );
};
